import { DXTPConnection, DXTPConnectionState } from '../common/DXTPConnection.js';
import { DeferredPromise } from '../common/index.js';
const MAX_RECONNECT_COUNT = 60;
const RECONNECT_DELAY_MS = 1000;
;
export class DXTPClientConnection extends DXTPConnection {
    constructor(options) {
        super(options);
        this.address = '';
        this.reconnectCounter = 0;
        this.stoppedReconnect = false;
        this.initPromises = [];
        if (!options.socketFactory) {
            throw new Error('Null socketFactory for DXTPClientConnection');
        }
        this.socketFactory = options.socketFactory;
        this.onConnectionOpen = options.onConnectionOpen;
        this.onConnectionClose = options.onConnectionClose;
        super.setIncomingRequestHandler(options.requestHandler);
        this.maxReconnectCount = options?.maxReconnectCount ?? MAX_RECONNECT_COUNT;
        this.reconnectDelayMs = options?.reconnectDelayMs ?? RECONNECT_DELAY_MS;
        if (options.address) {
            this.reset(options.address);
        }
    }
    reset(address) {
        console.log(`DXTPClientConnection: reset from [${this.getSocket()?.getAddress()}] to [${address}]`);
        this.address = address;
        this.reconnectCounter = 0;
        this.stoppedReconnect = false;
        this.reconnect();
    }
    getAddress() {
        return this.address;
    }
    async waitForConnected() {
        switch (this.getState()) {
            case DXTPConnectionState.Connected: return;
            case DXTPConnectionState.Pending: {
                const prom = new DeferredPromise();
                this.initPromises.push(prom);
                return prom.promise();
            }
            default: throw new Error(`Invalid connection state [${DXTPConnectionState[this.getState()]}]`);
        }
    }
    overrideState(state) {
        super.setState(state);
    }
    reconnect() {
        this.setSocket(null);
        if (!this.address) {
            super.setState(DXTPConnectionState.Disconnected);
            return;
        }
        super.setState(DXTPConnectionState.Pending);
        console.log(`DXTPClientConnection: connecting to [${this.address}]`);
        const socket = this.socketFactory(this.address);
        socket.setOpenHandler(this.onSocketOpen.bind(this));
        socket.setCloseHandler(this.onSocketClose.bind(this));
        this.setSocket(socket);
    }
    onSocketOpen() {
        console.log(`DXTPClientConnection: onSocketOpen [${this.getSocket()?.getAddress()}]`);
        this.reconnectCounter = 0;
        super.setState(DXTPConnectionState.Connected);
        if (this.onConnectionOpen) {
            this.onConnectionOpen();
        }
        this.initPromises.forEach(prom => prom.resolve());
        this.initPromises = [];
    }
    onSocketClose() {
        console.log(`DXTPClientConnection: onSocketClose [${this.getSocket()?.getAddress()}]`);
        if (this.reconnectCounter < this.maxReconnectCount && !this.stoppedReconnect) {
            this.reconnectCounter += 1;
            console.log(`Scheduled reconnect ${this.reconnectCounter} / ${this.maxReconnectCount} [${this.getSocket()?.getAddress()}]`);
            super.setState(DXTPConnectionState.Pending);
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = setTimeout(() => this.reconnect(), this.reconnectDelayMs);
        }
        else {
            console.log(`DXTPClientConnection: disconnected [${this.getSocket()?.getAddress()}]`);
            super.setState(DXTPConnectionState.Disconnected);
            if (this.onConnectionClose) {
                this.onConnectionClose();
            }
            this.initPromises.forEach(prom => prom.reject('Failed to connect'));
            this.initPromises = [];
        }
    }
    close() {
        console.log(`DXTPClientConnection: close [${this.getSocket()?.getAddress()}]`);
        this.stoppedReconnect = true;
        clearTimeout(this.reconnectTimer);
        super.setSocket(null);
        super.setState(DXTPConnectionState.Disconnected);
    }
}
//# sourceMappingURL=DXTPClientConnection.js.map